import { render } from "./AppFooter.vue?vue&type=template&id=3e818448"
const script = {}
script.render = render

export default script